import {getDb} from "./Constants";
import {collection, doc, getDoc, getDocs, query, setDoc, updateDoc, where,} from "firebase/firestore";
import {getDownloadURL, getStorage, ref, uploadBytes} from "firebase/storage";
import {v4 as uuidv4} from "uuid";
import moment from "moment";

export const getSelectedObject = (value, array) => {
    return array.find((obj) => obj.value === value);
};



export const uploadFileToFirebaseStorageAndGetDownloadUrl = async (
    fileState,
    eventID
) => {
    try {
        //   check the file extention
        const fileExtension = fileState.name
            .split(".")
            .pop()
            .toString()
            .toLowerCase();

        if (
            fileExtension !== "pdf" &&
            fileExtension !== "doc" &&
            fileExtension !== "docx" &&
            fileExtension !== "jpg" &&
            fileExtension !== "jpeg" &&
            fileExtension !== "png" &&
            fileExtension !== "gif" &&
            fileExtension !== "webp" &&
            fileExtension !== "svg" &&
            fileExtension !== "tiff"
        ) {
            return false;
        }
        const storage = getStorage(); // Create Firebase storage object
        const storageRef = ref(storage); // Get the root reference

        const folderRef = ref(storageRef, `candidateFlow/${eventID}`); // Create a reference for the folder

        // upload the file with some fake name inside the folder and do not overwrite the file if it already exists
        const newFileKey = await uuidv4();
        const newFileName = `${newFileKey}.${fileExtension}`;

        await uploadBytes(ref(folderRef, newFileName), fileState); // Upload the file

        const downloadURL = await getDownloadURL(ref(folderRef, newFileName)); // Get the download URL for the uploaded file

        return downloadURL;
    } catch (err) {
        return false;
    }
};

export const saveToFirebase = async (collectionName, documentId, data, id) => {
    console.log(data, "submitting this data to candidate document");
    const db = getDb();
    const collectionRef = collection(db, collectionName);
    const q = query(
        collectionRef,
        where("email_insensitive", "==", data?.email?.toLowerCase()),
        where("companyId", "==", id)
    );
    const docSnaps = await getDocs(q);
    console.log(docSnaps, "Doc snaps");
    try {
        if (docSnaps.docs.length > 0) {
            console.log("updating candidate", docSnaps.docs);
            const existingRef = docSnaps.docs[0].ref;
            await updateDoc(existingRef, {
                ...data,
            });
            return true;
        } else {
            console.log("creating new candidate");
            await setDoc(doc(db, collectionName, documentId), {
                ...data,
                companyId: id,
                createdAt: moment().unix(),
                shortlisted: true,
            });
            return true;
        }
    } catch (err) {
        console.log(err, "Error in saving to firebase");
        return false;
    }
};

export const updateCandidateConfig = async (
    collectionName,
    documentId,
    data
) => {
    console.log(data, "submitting this data to candidate config document");
    const db = getDb();
    const collectionRef = collection(db, collectionName);

    try {
        // Attempt to update the existing document with new data
        await updateDoc(doc(db, collectionName, documentId), {
            ...data,
            updatedAt: moment().unix(), // Optional: track when the document was last updated
        });
        console.log("Candidate config updated successfully.");
        return true;
    } catch (err) {
        console.error("Error updating candidate config:", err);
        return false;
    }
};

export const fetchCandidateConfig = async (collectionName, documentName) => {
    try {
        const db = getDb();
        const docRef = doc(db, collectionName, documentName);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            return docSnap.data(); // Returns document data if it exists
        } else {
            console.error("No such document!");
            return null;
        }
    } catch (error) {
        console.error("Error fetching document:", error);
        return null;
    }
};
